// src/components/StatusIndicator.js
import React from 'react';
import './StatusIndicator.css';

const StatusIndicator = ({ status }) => {
  // --- CASO 1: PROGRESSO (Pizza / Gráfico) ---
  // Ex: { current: 1, target: 2, status: 'warning' }
  if (typeof status === 'object' && status !== null && status.target !== undefined) {
    const { current, target, status: colorStatus } = status;
    
    // Evita divisão por zero e limita a 100%
    const safeTarget = target === 0 ? 1 : target;
    const percentage = Math.min(100, Math.max(0, (current / safeTarget) * 100));
    
    // Define a cor
    let colorCode = '#ef4444'; // Vermelho (Padrão)
    if (colorStatus === 'ok') colorCode = '#22c55e'; // Verde
    else if (colorStatus === 'warning') colorCode = '#f59e0b'; // Amarelo
    else if (colorStatus === 'critical') colorCode = '#ef4444'; // Vermelho

    // Estilo do Gráfico Cônico (Pizza)
    const style = {
      background: `conic-gradient(${colorCode} ${percentage}%, #e2e8f0 ${percentage}% 100%)`,
      width: '22px', // Tamanho padrão discreto
      height: '22px',
      borderRadius: '50%',
      transform: 'rotate(-90deg)', // Começa do topo (12h)
      transition: 'background 0.3s ease'
    };

    // Tooltip informativa
    const titleText = `${current}/${target} realizado(s) - ${Math.round(percentage)}%`;

    return (
      <div className="status-indicator-wrapper" title={titleText}>
        <div style={style}></div>
      </div>
    );
  }

  // --- CASO 2: STATUS SIMPLES (Bolinha Cheia) ---
  let finalStatus = status;
  if (status === 'ok') finalStatus = 'completed';
  if (status === 'warning') finalStatus = 'partial';
  if (status === 'critical') finalStatus = 'incomplete';
  
  if (!['completed', 'partial', 'incomplete'].includes(finalStatus)) {
      finalStatus = 'incomplete';
  }

  const statusTitle = {
    completed: 'Em dia',
    partial: 'Atenção',
    incomplete: 'Pendente',
  }[finalStatus];

  return <div className={`status-indicator ${finalStatus}`} title={statusTitle}></div>;
};

export default StatusIndicator;